require('./lbaHotel.scss');

const $inject = [];
const lbaHotel = function () {
  return {
    restrict: 'A',
    scope:{
    },
    bindToController: true,
    controller: 'lbaHotelCtrl',
    controllerAs: 'vm',
    template: require('./lbaHotel.html')
  }
};

lbaHotel.$inject = $inject;

export default lbaHotel;


// WEBPACK FOOTER //
// ./src/components/lbaHotel/lbaHotelDir.js